// extracted by mini-css-extract-plugin
export default {"heads":"Goals_heads__XbCyJ","main":"Goals_main__+Fv7q","goals":"Goals_goals__UYjCW","btn":"Goals_btn__za3F5"};